var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 62624",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.023,
    height: 33.237,
    viewBox: "0 0 33.023 33.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "f0ip9k25ta",
    cx: -0.004,
    cy: 0.511,
    r: 0.992,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff436d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#fe2743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe1020"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13048"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9219",
    d: "M2937.024 4523.118a16.512 16.512 0 1 1-16.512-16.618 16.576 16.576 0 0 1 16.512 16.618z",
    transform: "translate(-2904 -4506.5)",
    style: {
      fill: "url(#f0ip9k25ta)"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13051"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13049",
    transform: "translate(20.025 11.032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 164",
    cx: 2.178,
    cy: 2.192,
    rx: 2.178,
    ry: 2.192
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13050",
    transform: "translate(8.783 11.032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 165",
    cx: 2.178,
    cy: 2.192,
    rx: 2.178,
    ry: 2.192
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13052"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9220",
    d: "M9.415 26.448a4.656 4.656 0 0 1 .844-2.121 6.194 6.194 0 0 1 1.756-1.558 8.419 8.419 0 0 1 4.5-1.2 9.114 9.114 0 0 1 4.5 1.2 6.2 6.2 0 0 1 1.757 1.556 4 4 0 0 1 .843 2.121.069.069 0 0 1-.07.071h-.071a6.082 6.082 0 0 0-3.232-2.333 8.736 8.736 0 0 0-1.827-.5 8.6 8.6 0 0 0-1.9-.141 17.1 17.1 0 0 0-1.9.141 7.71 7.71 0 0 0-1.827.5 6.942 6.942 0 0 0-3.232 2.333.218.218 0 0 1-.14-.071z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.44fa3f5364720dd243b5567c6490e0ea.svg";
export { ForwardRef as ReactComponent };